import React from 'react';
import { Spin } from 'antd';

function Loader({
  children,
  isLoading,
  size = 'large',
}) {
  return (
    <>
      { isLoading ? (
        <div className="text-center">
          <Spin size={size} />
        </div>
      ) : children }
    </>
  );
}

export default Loader;
